/**
 * @file
 * @author dailin01
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useCallback, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import OutlinedMenuFold from 'acud-icon/lib/icons/OutlinedMenuFold';
import OutlinedMenuUnfold from 'acud-icon/lib/icons/OutlinedMenuUnfold';
import OutlinedTreeRight from 'acud-icon/lib/icons/OutlinedTreeRight';
import classnames from 'classnames';
import Tooltip from '../tooltip';
import RcMenu from './rc-menu';
import { cloneElement } from '../_util/reactNode';
import { ConfigContext } from '../config-provider';
import { useLocaleReceiver } from '../locale-provider/LocaleReceiver';
const GlobalSiderBar = props => {
    const { 
    // Menu本身配置
    prefixCls: customizePrefixCls, className, mode = 'horizontal', inlineCollapsed, expandIcon, scope, onCollapse, collapsible = true, collapsePosition = 'bottom', withHead, headIcon, headTip, headPopupClassName, onHeadClick, collapsedShowFirst = false } = props, rest = __rest(props, ["prefixCls", "className", "mode", "inlineCollapsed", "expandIcon", "scope", "onCollapse", "collapsible", "collapsePosition", "withHead", "headIcon", "headTip", "headPopupClassName", "onHeadClick", "collapsedShowFirst"]);
    // siderbar
    const [collapsed, setCollapsed] = useState(inlineCollapsed);
    const [menuLocale] = useLocaleReceiver('Menu');
    const toggleCollapsed = useCallback(() => {
        setCollapsed(collapsed => !collapsed);
        onCollapse === null || onCollapse === void 0 ? void 0 : onCollapse(!collapsed);
    }, [collapsed, onCollapse]);
    useEffect(() => {
        setCollapsed(inlineCollapsed);
    }, [inlineCollapsed]);
    const isCollapseRight = collapsePosition === 'right';
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('menu', customizePrefixCls);
    // 折叠时隐藏menu
    const hiddenMenu = useMemo(() => !collapsedShowFirst && isCollapseRight && collapsed, [collapsedShowFirst, isCollapseRight, collapsed]);
    const siderbarClassName = classNames({
        [`${prefixCls}-global-siderbar`]: true,
        [`${prefixCls}-global-collapsed`]: collapsed,
        [`${prefixCls}-global-siderbar-right-collapse`]: isCollapseRight,
        [`${prefixCls}-global-collapsed-hidden`]: hiddenMenu
    });
    const menuClassName = classNames(className, {
        [`${prefixCls}-${scope}`]: scope
    });
    const menuHead = useMemo(() => {
        if (!withHead) {
            return null;
        }
        ;
        const copyIcon = cloneElement(headIcon, {
            className: `${prefixCls}-global-siderbar-head-icon`
        });
        let headContent;
        if (!collapsed) {
            headContent = (<>
                    {copyIcon}
                    <span className={`${prefixCls}-global-siderbar-head-text`}>{withHead}</span>
                </>);
        }
        else if (headIcon) {
            headContent = copyIcon;
        }
        else if (typeof withHead === 'string' && withHead.length) {
            headContent = (<span>{withHead.charAt(0)}</span>);
        }
        if (headTip) {
            headContent = (<Tooltip title={headTip} placement="right" overlayClassName={classnames(`${prefixCls}-global-siderbar-tooltip`, headPopupClassName)}>
                    {headContent}
                </Tooltip>);
        }
        return (<div onClick={onHeadClick} className={`${prefixCls}-global-siderbar-head`}>
                {headContent}
            </div>);
    }, [withHead, headIcon, prefixCls, collapsed, headTip, onHeadClick, headPopupClassName]);
    const collapseNav = useMemo(() => {
        if (!collapsible) {
            return null;
        }
        if (isCollapseRight) {
            return (<div className={`${prefixCls}-right-nav section-collapse`} onClick={toggleCollapsed}>
                    <OutlinedTreeRight className="collapse-icon"></OutlinedTreeRight>
                </div>);
        }
        const SwitchIcon = collapsed ? OutlinedMenuUnfold : OutlinedMenuFold;
        const switchText = collapsed ? menuLocale.unfold : menuLocale.fold;
        return (<div className={`${prefixCls}-bottom-nav`}>
                <span className={`${prefixCls}-bottom-nav-fold`} onClick={toggleCollapsed}>
                    <SwitchIcon className={`${prefixCls}-bottom-nav-fold-icon`}/>
                    <span className={`${prefixCls}-bottom-nav-fold-label`}>{switchText}</span>
                </span>
            </div>);
    }, [collapsed, collapsible, isCollapseRight, toggleCollapsed]);
    return (<div className={siderbarClassName}>
            {menuHead}
            <RcMenu prefixCls={prefixCls} className={menuClassName} expandIcon={cloneElement(expandIcon, {
            className: `${prefixCls}-submenu-expand-icon`
        })} inlineCollapsed={collapsed} mode={mode} {...rest}/>
            {collapseNav}
        </div>);
};
export default GlobalSiderBar;
